import { FunctionComponent, memo, useContext } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { DetailsModalContext } from '../../../../context';
import { NotificationComment } from '../../../../services';
import { layoutPath } from '../../../utils';
import { NotificationWrapper } from '../NotificationWrapper';
import { CommentContent } from './CommentContent';

interface CommentProps {
  notification: NotificationComment;
  setIsOpen: (isOpen: boolean) => void;
  logOpen: (notification_id: number) => void;
}

export const Comment: FunctionComponent<CommentProps> = memo(
  ({ notification, setIsOpen, logOpen }) => {
    const navigate = useNavigate();

    const { setDetailsModalData } = useContext(DetailsModalContext);

    const { id, deliveredTime, action, comment, parentComment, author } = notification;

    const { story, storyCard } = comment;

    const onClickHandler = () => {
      if (story && storyCard) {
        const { id: storyId } = story;
        const { id: cardId } = storyCard;

        isMobileOnly
          ? navigate(layoutPath(`/details/${storyId}/${cardId}?scrollToComments=true`))
          : setDetailsModalData({ storyId, cardId, scrollToComments: true });

        logOpen(id);
      }

      setIsOpen(false);
    };

    const { id: userId, avatar } = author;

    return (
      <NotificationWrapper
        key={id}
        userId={userId}
        avatarUrl={avatar?.url}
        deliveredTime={deliveredTime}
        onClick={onClickHandler}
        hasLink
      >
        <CommentContent
          commentAction={action}
          comment={comment}
          parentComment={parentComment}
          author={author}
        />
      </NotificationWrapper>
    );
  }
);
